export default "__VITE_ASSET__DX4vJYNE__"